import $ from 'jquery'
import 'jquery-validation/dist/jquery.validate.min'

export default {
  init() {
    $.extend(jQuery.validator.messages, {
      required: 'Ce champs est requis',
      email: 'Cet email n\'est pas valide',
    });

    $('form').validate({
      submitHandler: function(form) {
        form.submit();
      },
    })
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-connexion.js